import React, { useCallback, useState } from "react";
// import components
import DCard from "../components/DCard";
import { Heading, Spinner } from "@chakra-ui/react";
import FormikContainer from "../components/Formik/FormikContainer";
import FieldContainer from "../components/Formik/FieldContainer";
import DButton from "../components/DButton";
import { Form } from "formik";

// import utils
import * as Yup from "yup";
import { icon } from "../utils/icons";
import authServices from "../services/auth";
import { useDispatch } from "react-redux";
import { getCategories, setAuth } from "../redux/slicers/config";
import { setCookie } from "../utils/functions";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const initialValues = {
  username: "",
  password: "",
};
const validationSchema = Yup.object().shape({
  username: Yup.string().required("هذا الحقل مطلوب"),
  password: Yup.string().required("هذا الحقل مطلوب"),
});
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false); // show / hide password state
  // show / hide password handler
  const passwordToggleHandler = useCallback(() => {
    setShowPassword(!showPassword);
  }, [showPassword]);
  const onSubmit = (values, { setSubmitting }) => {
    authServices
      .login(values)
      .then((res) => {
        if (res.data.data.role === "admin") {
          localStorage.setItem(
            "telegram_authorize",
            JSON.stringify(res.data.data.telegram_authorize)
          );
          localStorage.setItem("role", JSON.stringify(res.data.data.role));
          localStorage.setItem("username", JSON.stringify(values.username));
          setCookie("dc-auth", res.data.data.api_key, res.data.data.expires);
          if (res.data.data.telegram_authorize) {
            toast.success("يرجى تأكيد الدخول");
            setTimeout(() => {
              navigate("/wating-page", { replace: true });
            }, 1500);
          } else {
            dispatch(
              setAuth({
                telegramAuthorize: JSON.parse(
                  localStorage.getItem("telegram_authorize")
                ),
                username: values.username,
                role: res.data.data.role,
              })
            );
            dispatch(getCategories());

            localStorage.removeItem("username");
            localStorage.removeItem("telegram_authorize");
            localStorage.removeItem("role");
            toast.success("تم الدخول");
            setTimeout(() => {
              navigate("/", { replace: true });
            }, 1500);
          }
        } else {
          toast.error("خطأ في اسم المستخدم او كلمة المرور");
          setSubmitting(false);
        }
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          toast.error("خطأ في اسم المستخدم او كلمة المرور");
        } else {
          toast.error("حصل خطا ما في السيرفر");
        }
        setSubmitting(false);
      });
  };
  return (
    <DCard className="fixed w-[90%] mx-auto sm:w-2/4 xl:w-1/4  top-2/4 start-2/4 translate-x-2/4 -translate-y-2/4 bg-white">
      <div className="text-center mb-4 text-third-color">
        <Heading as={"h1"}>تسجيل الدخول</Heading>
        <p>الى لوحة التحكم</p>
      </div>
      <FormikContainer
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        initialValues={initialValues}
      >
        {({ isSubmitting }) => (
          <Form className="text-third-color">
            <FieldContainer
              type="text"
              name="username"
              label="اسم المستخدم"
              id="username"
            />
            <FieldContainer
              type={showPassword ? "text" : "password"}
              name="password"
              label="كلمة المرور"
              id="password"
            >
              <DButton
                onClick={passwordToggleHandler}
                varient="transparent"
                className="absolute end-0 h-full text-xl text-light-color"
              >
                {showPassword ? icon.eyeHide : icon.eyeShow}
              </DButton>
            </FieldContainer>
            <DButton
              disabled={isSubmitting}
              type="submit"
              className="w-full flex items-center justify-center text-white"
            >
              {isSubmitting ? <Spinner /> : "تسجيل الدخول"}
            </DButton>
          </Form>
        )}
      </FormikContainer>
    </DCard>
  );
};

export default Login;
